export const INVALIDATE_EMPTY_ASSETS_SECONDS = 1;
